/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField, Zoom } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { ThemButton } from "../../Login/Login.style";
import { SyncLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleAddClose, handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, InputDiv } from "../../style/Table.style";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const EditThana = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const thanaData = useSelector((state) => state.Modal.val);

  const schema = yup.object().shape({});
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });


  const upazila_id = thanaData.upazila_id;
  const onSubmit = (data) => {
  
    
    setIsLoading(true);
    const formData = new FormData();
  
    formData.append("distict_id", thanaData?.distict_id);
    formData.append("dzila_name", thanaData?.dzila_name);
    formData.append("astatus_fg", data?.astatus_fg);
    formData.append("thana_code", data?.thana_code);
    formData.append("thana_name", data?.thana_name);
    
    fetch(`${process.env.REACT_APP_API_URL}/api/updateThana/${upazila_id}`, {
      method: "POST",
      body: formData,
    })
    .then((res) => {
      console.log("Response status:", res.status);
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      return res.json(); 
    })
    .then((data) => {
      if (data === "Update Succesfully") { 
        toast.success("Study Update Successful", {
          position: toast.POSITION.TOP_CENTER
        });
      }
      dispatch(handleEditClose());
    })
    .catch((error) => {
      console.error("Error during fetch:", error);
    })
    .finally(() => setIsLoading(false));
  };
  
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box p="20px">
          <TextField
            size="small"
            name="thana_code"
            fullWidth
            label="Thana Code*"
            defaultValue={thanaData?.thana_code}
            variant="outlined"
            {...register("thana_code", { required: true })}
          />
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            size="small"
            name="thana_name"
            fullWidth
            label="Police Station Name*"
            defaultValue={thanaData?.thana_name}
            variant="outlined"
            {...register("thana_name", { required: true })}
          />
        </Box>
        <Box p=" 0 20px 20px 20px">
          <TextField
            select
            name="astatus_fg"
            size="small"
            fullWidth
            label="Active Status*"
            variant="outlined"
            defaultValue={thanaData?.astatus_fg}
            {...register("astatus_fg")}
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Inactive</MenuItem>
          </TextField>
          {errors?.astatus_fg && (
            <ErrorMessage>{errors.astatus_fg.message}</ErrorMessage>
          )}
        </Box>
        <Box
          marginTop="20px"
          style={{
            margin: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          {isLoading ? (
            <ThemButton style={{}} type="submit">
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton
              style={
                {
                  // width: "30%",
                }
              }
              type="submit"
            >
              Update Thana
            </ThemButton>
          )}
        </Box>

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </form>
    </>
  );
};
export default EditThana;
